"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlOcppAuthorizedTransactionsSerialization = void 0;
const OcppAuthorizedTransactionSerialization_1 = require("./OcppAuthorizedTransactionSerialization");
class ChargerControlOcppAuthorizedTransactionsSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.authorizations = entity.authorizations?.map((field) => field
            ? JSON.parse(OcppAuthorizedTransactionSerialization_1.OcppAuthorizedTransactionSerialization.serialize(field))
            : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.authorizations = entity.authorizations?.map((field) => field
            ? OcppAuthorizedTransactionSerialization_1.OcppAuthorizedTransactionSerialization.deserialize(JSON.stringify(field))
            : undefined);
        return copy;
    }
}
exports.ChargerControlOcppAuthorizedTransactionsSerialization = ChargerControlOcppAuthorizedTransactionsSerialization;
